import { Button, Form, FormProps, Input, Select, Space, TimePicker } from 'antd'
import Modal from 'antd/es/modal/Modal'
import React, { useEffect, useState } from 'react'
import './timeSlotModal.scss'
import TimeSelector from '../../Timpicker/timepicker'
import dayjs from 'dayjs'
import Icon, { CloseOutlined } from '@ant-design/icons'
import CustomTimeRangePicker from '../../Timpicker/CustomTimeRangePicker'
const TimeSlotModal = ({
  visible,
  onCancel,
  timeSlots,
  changeTimeSlots
}: any) => {
  const [timeSlotsState, setTimeSlotsState] = useState(timeSlots)
  useEffect(() => {
    // Ensure "All Day" default time slot exists
    const hasAllDay = timeSlots.some(
      (slot: any) => slot.slotName === 'All Day' && slot.type === 'DEFAULT'
    )
    if (!hasAllDay) {
      const allDaySlot = {
        slotName: 'All Day',
        availableHours: {
          from: '12:00 AM',
          to: '11:59 PM'
        },
        type: 'DEFAULT'
      }
      setTimeSlotsState([allDaySlot, ...timeSlots])
    } else {
      setTimeSlotsState(timeSlots)
    }
  }, [timeSlots])

  const [form] = Form.useForm()
  const format = 'h:mm A'
  const handleModalClose = () => {
    changeTimeSlots(timeSlotsState)
  }

  const onClose = () => {
    onCancel()
  }

  const addCustomTimeSlot = (values: any) => {
    console.log(values)
    const from = dayjs(values.timeRange[0]).format('hh:mm A')
    const to = dayjs(values.timeRange[1]).format('hh:mm A')

    timeSlotsState.push({
      slotName: values.timeSlotName,
      availableHours: {
        from,
        to
      },
      type: 'CUSTOM'
    })
    setTimeSlotsState([...timeSlotsState])
    form.resetFields()
  }

  const deleteCustomTimeSlot = (slotName: string) => {
    const index: number = timeSlotsState.findIndex(
      (timeSlot: any) => timeSlot.slotName === slotName
    )
    console.log(index)
    timeSlotsState.splice(index, 1)
    setTimeSlotsState([...timeSlotsState])
  }

  return (
    <Modal
      title={'Available Time Slots'}
      centered
      open={visible}
      footer={
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
          <Button type='primary' onClick={() => handleModalClose()}>
            OK
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </div>
      }
      style={{ textAlign: 'center', width: '100%' }}
    >
      <div className='indvTime'>
        {timeSlotsState.map((slot: any) => {
          return (
            <div
              style={{ borderBottom: '1px solid red', margin: '6px' }}
              key={slot.slotName}
            >
              <div
                className='name'
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                Name: {slot.slotName}
                {slot.type === 'CUSTOM' && (
                  <CloseOutlined
                    onClick={() => deleteCustomTimeSlot(slot.slotName)}
                  />
                )}
              </div>
              <div className='range'>
                From: {slot.availableHours.from} - To: {slot.availableHours.to}{' '}
              </div>
            </div>
          )
        })}
      </div>
      <h3>Add Custom </h3>
      <Form
        form={form}
        name='basic'
        layout='vertical'
        initialValues={{ remember: true }}
        onFinish={addCustomTimeSlot}
        autoComplete='off'
      >
        <Form.Item label='Time slot name' name='timeSlotName'>
          <Input placeholder='Name Of Time slot' />
        </Form.Item>
        <Form.Item label='Time Range' name='timeRange'>
          <CustomTimeRangePicker
            style={{ width: '100%' }}
            use12Hours
            format={format}
          />
        </Form.Item>
        <Form.Item>
          <Button type='primary' htmlType='submit' style={{ width: '100%' }}>
            Add Time Slot
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default TimeSlotModal
